const HowToEnter = ({competition,toggleGuidelines,platforms, modal, setModal}) => {
    return (
      <div className="card p-3">
        <div className="section-title">
          <h5 className="madeGentle border-bottom pb-2">How To Enter</h5>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <p
              className="text-muted Archivo"
              style={{
                display: "flex",
                flexDirection: "row",
                overflow: "auto",
              }}
            >
              <span>1.</span>
              {competition && competition.creativeDirection ? (
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: competition.creativeDirection,
                    }}
                    style={{ overflow: "auto" }}
                  ></div>
                </>
              ) : (
                <span className="ml-2 Archivo">
                  Post a public{" "}
                  {!platforms
                    ? "TikTok"
                    : platforms.map((e, i) => {
                        if (i >= 1) {
                          return `or ${e} `;
                        } else {
                          return `${e} `;
                        }
                      })}{" "}
                  that features the song:{" "}
                  <a
                    target="_blank"
                    href={competition && competition.audio}
                    className="text-pink"
                  >
                    <i>{competition && competition.name}</i> by{" "}
                    <i>{competition && competition.organizer}</i>
                  </a>
                  .
                </span>
              )}
            </p>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <p
              className="text-muted Archivo"
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <span>2.</span>
              <span className="ml-2">
                The song must be clearly heard in the video and the post must
                follow our{" "}
                <a
                  style={{ cursor: "pointer", color: "#f853bd" }}
                  onClick={toggleGuidelines}
                >
                  guidelines.
                </a>
              </span>
            </p>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <p className="text-muted Archivo">
              <span>3.</span>
              <span className="ml-2">Submit a link to the post </span>
              <span
                className={`text-pink cursor-pointer `}
                onClick={() => {
                  setModal(!modal);
                }}
              >
                here
              </span>
            </p>
          </div>
        </div>
      </div>
    );
}

export default HowToEnter;